const calendarQuarterBounds: ReadonlyArray<{
  quarter: string;
  start: string;
  end: string;
}> = [
  { quarter: 'Q1', start: '01-01', end: '03-31' },
  { quarter: 'Q2', start: '04-01', end: '06-30' },
  { quarter: 'Q3', start: '07-01', end: '09-30' },
  { quarter: 'Q4', start: '10-01', end: '12-31' },
];

export type CalendarReportingPeriod = {
  reporting_date: string;
};

export type CalendarQuarterTimeframe = {
  label: string;
  startDate: string;
  endDate: string;
};

export const getCalendarQuarterFromReportingDate = (
  reportingDate: string
): CalendarQuarterTimeframe => {
  const date = new Date(reportingDate);
  const year = date.getUTCFullYear();
  const quarter = calendarQuarterBounds[Math.floor(date.getUTCMonth() / 3)];

  return {
    label: `${quarter.quarter} ${year}`,
    startDate: `${year}-${quarter.start}`,
    endDate: `${year}-${quarter.end}`,
  };
};
